import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE_GET_ALL } from 'src/constants/pagination';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { actionGetAllCategory } from 'src/redux/actions/categoryByGroup';

const HeadC = dynamic(() => import('src/components/Head'));
const AllCategories = dynamic(() => import('src/containers/AllCategories'));

const AllCategoriesPage = () => {
	return (
		<>
			<HeadC title="Semua Kategori" description="Semua Kategori" />
			<AllCategories />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	await store.dispatch(
		actionGetAllCategory({
			page: DEFAULT_PAGE_INDEX,
			per_page: DEFAULT_PER_PAGE_GET_ALL,
			type: 'general',
		}),
	);

	return {
		props: {
			pageHeaderContent: {
				title: 'Semua Kategori',
				breadcrumbs: [{ label: 'Semua Kategori' }],
			},
			card: true,
			isWhiteBackground: true,
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default AllCategoriesPage;
